import Vue from 'vue';
import layoutAdmin from '@/layouts/layout-admin';

Vue.component('layout-admin', layoutAdmin);



// WEBPACK FOOTER //
// ./src/global-components.js